// src/pages/LeadershipHome.js
import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import LeadershipHero from '../components/Leadership/LeadershipHero';
import LeadershipOwnership from '../components/Leadership/LeadershipOwnership';
import PerformanceMeasurement from '../components/Leadership/PerformanceMeasurement';
import PeopleChange from '../components/Leadership/PeopleChange';
import BoardroomConfidence from '../components/Leadership/BoardroomConfidence';
import Footer from '../components/Footer';

// Declares the external profiles that represent this same organisation. `sameAs` is
// how Google associates an off-site profile with the entity — an iframe of the
// profile would not, since framed content is credited to the framed domain.
const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'EDSY Tech',
  url: 'https://edsytech.com',
  logo: 'https://edsytech.com/images/website.png',
  description:
    'Enterprise .NET SaaS architecture, Azure and AWS cloud engineering, DevOps, security baselines, and board-ready reliability services.',
  sameAs: [
    'https://www.upwork.com/agencies/edsytech/'
  ]
};

const LeadershipHome = () => {
  return (
    <div>
      <SEO
        title="Leadership & Governance Solutions | EDSY Tech"
        description="Executive leadership, governance, and performance measurement strategies for enterprise technology teams and board-ready business outcomes."
        canonicalPath="/"
        keywords="leadership, governance, executive technology, board readiness, performance measurement, enterprise transformation"
        jsonLd={jsonLd}
      />
      <Navbar />
      <LeadershipHero />
      <LeadershipOwnership />
      <PerformanceMeasurement />
      <PeopleChange />
      <BoardroomConfidence />
      <Footer />
    </div>
  );
};

export default LeadershipHome;